import { render, staticRenderFns } from "./UpcomingBattles.vue?vue&type=template&id=381f9096&scoped=true&"
import script from "./UpcomingBattles.vue?vue&type=script&lang=ts&"
export * from "./UpcomingBattles.vue?vue&type=script&lang=ts&"
import style0 from "./UpcomingBattles.vue?vue&type=style&index=0&id=381f9096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f9096",
  null
  
)

export default component.exports